import * as recall from '@otter-ai/recall-client';
import type { UseMutationOptions } from '@tanstack/react-query';

export type EndSpeechUploadArgs = recall.EndSpeechUploadData['query'];

export type EndSpeechUploadMutation = UseMutationOptions<
  recall.EndSpeechUploadResponses[200],
  Error,
  EndSpeechUploadArgs
>;

export type EndSpeechUploadMutationOptions = Omit<
  EndSpeechUploadMutation,
  'mutationFn'
>;

/**
 * Mutation creator for processing speech upload
 *
 * @example
 * ```
 * const { mutate: endSpeechUpload } = useMutation(
 *   endSpeechUploadMutationCreator()
 * );
 *
 * endSpeechUpload({
 *   bucket: '1234',
 *   key: '111',
 *   appid: 'zoom-sync
 * });
 * ```
 */
export function endSpeechUploadMutationCreator({
  ...options
}: EndSpeechUploadMutationOptions): EndSpeechUploadMutation {
  return {
    ...options,
    mutationFn: async (args: EndSpeechUploadArgs) => {
      const response = await recall.endSpeechUpload({
        query: { ...args },
      });
      if (response.error) {
        throw response.error;
      }
      return response.data;
    },
  };
}
